export default {
  // Endpoints
  loginEndpoint: '/Clients/Auth/login',
  registerEndpoint: '/Clients/Auth/register',
  refreshEndpoint: '/Clients/Auth/refresh-token',
  logoutEndpoint: '/Clients/Auth/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
  storageDownloadTokenKeyName: 'downloadToken',
}
